import { gsap, ScrollTrigger } from "gsap/all";

const PinnedShareIcons = ($) => {
	gsap.registerPlugin(ScrollTrigger);
	let matchMedia = gsap.matchMedia();

	matchMedia.add("(min-width: 1300px)", () => {
		const trigger = $("#pin-trigger")[0];
		const shareContainer = $(".share-desktop")[0];

		ScrollTrigger.create({
			trigger: trigger,
			pin: shareContainer,
			start: "top 150px",
			end: "bottom-=500px top"
		});
	});
};

export default PinnedShareIcons;